import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { Icon } from '@holmescorp/base-widgets/icon';
import { createNlsMiddleware, documentapi, lccstate, userstate } from '@holmescorp/lcc-state';
import { publish } from '@holmescorp/pub-sub';
import { Breadcrumbs, Hero, MicroCardButton, getTestResultScore } from './index';
import css from '../css/final-test-view.m.css';
const factory = create({
    nls: createNlsMiddleware('ditabook'),
    theme,
    documentapi,
    lccstate,
    userstate
});
export const FinalTestView = factory(({ id, middleware: { theme, documentapi, nls, lccstate, userstate } }) => {
    const { messages: { practice_type = 'practice', assess_progress_threshold_high = '80', final_test_page_title = '[ditabook] final_test_page_title', final_test_button_label = '[ditabook] final_test_button_label', final_test_retake_button_label = '[ditabook] final_test_retake_button_label', final_test_passed_button_label = '[ditabook] final_test_passed_button_label', final_test_default_title = '[ditabook] final_test_default_title', final_test_default_subtitle = '[ditabook] final_test_default_subtitle', final_test_default_description = '[ditabook] final_test_default_description', final_test_passed_title = '[ditabook] final_test_passed_title', final_test_passed_subtitle = '[ditabook] final_test_passed_subtitle', final_test_passed_description = '[ditabook] final_test_passed_description', final_test_back_button = '[ditabook] final_test_back_button', logo_image_url = '', logo_image_alt = '', secondary_image_url = '', secondary_image_alt = '' } } = nls();
    const themeCss = theme.classes(css);
    documentapi.setTitle(final_test_page_title);
    const { get: uget, path: upath } = userstate;
    const passingScore = parseInt(assess_progress_threshold_high) || 80;
    const get_tree = (practice_type) => {
        const practiceResults = uget(upath('practice'));
        const posttestResults = uget(upath('posttest'));
        switch (practice_type) {
            case 'practice':
                return practiceResults;
            case 'posttest':
                return posttestResults.tree;
        }
        return {};
    };
    const tree = get_tree(practice_type);
    const ditaroots = lccstate.get(lccstate.path('ditaroots'));
    const fullPosttest = uget(upath('posttest'));
    const { score, hasTestResults: hasPosttest } = getTestResultScore(tree, ditaroots, practice_type, fullPosttest);
    const hasPassed = score >= passingScore;
    const labelText = hasPosttest
        ? hasPassed
            ? final_test_passed_button_label
            : final_test_retake_button_label
        : final_test_button_label;
    return v('div', { id, classes: [theme.variant(), themeCss.root] }, [
        w(Breadcrumbs, {}),
        v('div', { classes: [themeCss.content] }, [
            w(Hero, { additionalClasses: [themeCss.contentWrapper] }, [
                logo_image_url ? v('img', { src: logo_image_url, alt: logo_image_alt }) : null,
                v('div', { classes: [themeCss.copy] }, [
                    v('h2', { classes: [themeCss.title] }, [
                        hasPassed ? final_test_passed_title : final_test_default_title
                    ]),
                    v('h3', { classes: [themeCss.subtitle] }, [
                        hasPassed ? final_test_passed_subtitle : final_test_default_subtitle
                    ]),
                    secondary_image_url ? v('img', { src: secondary_image_url, alt: secondary_image_alt }) : null,
                    v('div', {
                        classes: [themeCss.description],
                        innerHTML: hasPassed ? final_test_passed_description : final_test_default_description
                    }),
                    v('div', { classes: [themeCss.actions] }, hasPassed
                        ? [
                            w(MicroCardButton, {
                                labelText,
                                disabled: true,
                                icon: w(Icon, { faname: 'arrow-left-long' }),
                                xqa: 'final-test-button',
                                iconPosition: 'before',
                                onClick: () => {
                                    publish(`site/${practice_type}`);
                                },
                                onDown: () => {
                                    publish(`site/${practice_type}`);
                                }
                            }),
                            w(MicroCardButton, {
                                labelText: final_test_back_button,
                                xqa: 'final-test-home-button',
                                icon: w(Icon, { faname: 'house' }),
                                darkMode: true,
                                iconPosition: 'before',
                                onClick: () => {
                                    publish(`site/homepage`);
                                },
                                onDown: () => {
                                    publish(`site/homepage`);
                                }
                            })
                        ]
                        : [
                            w(MicroCardButton, {
                                labelText: final_test_back_button,
                                xqa: 'final-test-home-button',
                                icon: w(Icon, { faname: 'arrow-left-long' }),
                                iconPosition: 'before',
                                onClick: () => {
                                    publish(`site/homepage`);
                                },
                                onDown: () => {
                                    publish(`site/homepage`);
                                }
                            }),
                            w(MicroCardButton, {
                                labelText,
                                darkMode: true,
                                icon: w(Icon, { faname: 'arrow-right-long' }),
                                xqa: 'final-test-button',
                                onClick: () => {
                                    publish(`site/${practice_type}`);
                                },
                                onDown: () => {
                                    publish(`site/${practice_type}`);
                                }
                            })
                        ])
                ])
            ])
        ])
    ]);
});
export default FinalTestView;
